<template>
  <div class="flex h-full min-h-0 flex-col">
    <DeviceStatusTabs class="shrink-0" />
    <DeviceList
      v-if="filteredDeviceIds.length > 0"
      class="min-h-0 flex-1"
      :device-ids="filteredDeviceIds"
    />
    <LoaderBlock v-if="isLoading" class="min-h-0 flex-1" />
    <NoData
      v-else-if="filteredDeviceIds.length === 0 && !isLoading"
      class="min-h-0 flex-1"
      title="There are no trackers"
      subtitle="Your trackers list is empty"
    />
  </div>
</template>

<script setup>
import DeviceList from '@/components/device/list/DeviceList.vue';
import DeviceStatusTabs from '@/components/device/list/DeviceStatusTabs.vue';
import LoaderBlock from '@/components/_common/LoaderBlock.vue';
import NoData from '@/components/_common/NoData.vue';

import { useDevice } from '@/composables/useDevice';
import { useTrackerListFilter } from '@/composables/useTrackerListFilter';
import { storeToRefs } from 'pinia';
import { setTitle } from '@/utils/title';

setTitle('All Trackers');

const { isLoading } = storeToRefs(useDevice());
const { filteredDeviceIds } = useTrackerListFilter(undefined, {
  syncToDeviceStore: true,
});
</script>
